import { InjectionToken } from '@angular/core';
import { FirebaseApp } from 'firebase/app';

export const Firebase = new InjectionToken<FirebaseApp>('Firebase');
